import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import {
  getAssetsAction,
  getFinancialInfoPropertiesAction,
  getFinancialInformationSummaryAction,
  getIncomesAction,
  getLiabilitiesAction,
} from 'store/loanApplications/actions';
import { selectEntityReferenceLoadedApplicationId } from 'store/loanApplications/selectors';

// Loads the Financial Info records the entity-reference picker/chips resolve candidates from,
// for ANY surface hosting a loan-internal composer (loan-editor drawer AND the Messages page) —
// without it the `#` picker is empty until the user visits the Financial Info tab. Skipped once
// already loaded for this application; ref-guarded against duplicate dispatch while in flight.
const useEnsureEntityReferenceData = applicationId => {
  const dispatch = useDispatch();
  const loadedApplicationId = useSelector(selectEntityReferenceLoadedApplicationId);
  const inFlightApplicationIdRef = useRef(null);

  const isLoadedForApplication =
    !!applicationId && loadedApplicationId?.toLowerCase() === applicationId.toLowerCase();

  useEffectSafeStrictMode(() => {
    if (
      !applicationId ||
      isLoadedForApplication ||
      inFlightApplicationIdRef.current === applicationId
    ) {
      return;
    }

    inFlightApplicationIdRef.current = applicationId;

    dispatch(getAssetsAction({ applicationId }));
    dispatch(getLiabilitiesAction({ applicationId }));
    dispatch(getIncomesAction({ applicationId }));
    dispatch(getFinancialInfoPropertiesAction({ applicationId }));
    dispatch(getFinancialInformationSummaryAction({ applicationId }));
  }, [applicationId, dispatch, isLoadedForApplication]);

  return { isLoadedForApplication };
};

export default useEnsureEntityReferenceData;
